import { FamilyGroup } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getFamilyGroup = async (familyId: string, locale: string): Promise<FamilyGroup> => {
  const url = `/family/${familyId}?include=available&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<FamilyGroup>(url);
  return response.data;
};
